module.exports = __webpack_public_path__ + "static/anx-3-492x328-55fcfce4ceece517adfeaa74d837ba5e.jpg";